export const MESSAGE_REQUIRED = 'を入力してください。';

export const MESSAGE_SELECT = 'を選択してください。';
export const MESSAGE_MAXLENGTH = 'は110文字以内で入力してください。';
export const MESSAGE_MINLENGTH = length => `は${length}文字以上で入力してください。`;
export const MESSAGE_MAXLENGTH_CUSTOM = length => `は${length}文字以内で入力してください。`;
export const MESSAGE_MIN = (value, unit = '') => `は${value}${unit}以上で入力してください。`;
export const MESSAGE_MAX = (value, unit = '') => `は${value}${unit}以内で入力してください。`;
export const MESSAGE_HIRAGANA_FORMAT = 'はひらがなのみで入力してください。';
export const MESSAGE_FORMAT = {
    EMAIL: 'メールアドレスの形式が正しくありません。',
    POSTAL_CODE: '郵便番号は「XXX-XXXX」の形式で入力してください。',
    PHONE: '電話番号を入力してください。',
    FAX: '正しい形式でFAX番号を入力してください。'
};
